/**
 * Prefixes a Vue Router path with the SPA's deploy base so it becomes a valid
 * origin-relative browser URL. The SPA is served from the site root (base `/`),
 * but a full-page navigation to an MVC endpoint (`/Account/Login?returnUrl=...`)
 * is resolved by the browser against the origin — the `returnUrl` we hand over
 * must therefore carry the base so the login round-trip lands back in the SPA.
 * Kept base-aware (via `import.meta.env.BASE_URL`) so the app still works if it
 * is ever republished under a sub-path.
 *
 * `window.location.pathname` already includes the base; only router-derived
 * paths need this.
 *
 * @param routerPath in-app path from Vue Router, e.g. `/dashboard?tab=1`
 * @returns origin-relative URL, e.g. `/dashboard?tab=1`
 */
export function toAppPath(routerPath: string): string {
  // BASE_URL always carries a trailing slash ('/' at root); drop it so we don't
  // double up with the leading slash of the router path.
  const base = import.meta.env.BASE_URL.replace(/\/$/, '')
  return routerPath.startsWith('/') ? `${base}${routerPath}` : `${base}/${routerPath}`
}
